module.exports = __webpack_public_path__ + "laptop-iso.png?d2a12bc574a203af3b21766469c73715";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/laptop-iso.png
// module id = 141
// module chunks = 0